export default __webpack_public_path__ + "static/media/Q17_3_resized.e9ab2c25.jpg";